import type { GetProjects } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { projectsByOwnerKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetProjectsByOwnerOfUser(userId: string) {
  return useQuery({
    queryFn: () =>
      apiClient
        .url(`/users/projects-by-owner/${userId}`)
        .get()
        .json<GetProjects>(),
    queryKey: projectsByOwnerKeys.byUserId(userId),
  });
}
